import React from 'react'
import { noop } from 'lodash-es'
import { DealSettlement } from 'api'
import { DialogField } from 'view/components/inputs'
import { CsdSelectboxField } from 'view/shared/entity'
import { Locale, Translation } from 'locale'

interface BilateralClearingSectionProps {
  readOnly: boolean
  csd: DealSettlement | null
  onChangeCsd: (csd: DealSettlement | null) => unknown
}

export const BilateralClearingSection: React.FunctionComponent<BilateralClearingSectionProps> = props => {
  const { csd } = props

  return (
    <DialogField>
      <CsdSelectboxField
        canClear
        dataTestId={'BilateralClearingSection-CsdSelectboxField-CSD'}
        label={Locale.translate(Translation.TC_CSD)}
        value={csd}
        readOnly={props.readOnly}
        onUpdate={props.readOnly ? noop : props.onChangeCsd}
        disabled={props.readOnly}
      />
    </DialogField>
  )
}
